import ComparativeAnalysisCard from "./components/cards/comparativeAnalysis/ComparativeAnalysisCard";
import CompetencesCard from "./components/cards/competences/CompetencesCard";
import HistoricalDataCard from "./components/cards/historical/HistoricalCard";
import RecommendationsCard from "./components/cards/recommendations/RecommendationsCard";
import ResultsByTestCard from "./components/cards/resultsByTest/ResultsByTestCard";
import ThematicAreasCard from "./components/cards/thematicAreas/ThematicAreasCard";
import type { dashboardSection } from "./types.props";

export const baseSectionsConfig: dashboardSection[] = [
    {
        id: "results",
        component: ResultsByTestCard,
        getProps: ({ dashboardData }) => ({ tests: dashboardData?.tests }),
        isFixed: true,
    },
    {
        id: "comparative",
        component: ComparativeAnalysisCard,
        getProps: ({ dashboardData }) => ({
            tests: dashboardData?.tests,
        }),
        extraProps: {
            view: "vsInstitution",
            showTabs: true,
        },
    },

    {
        id: "competences",
        component: CompetencesCard,
        getProps: ({ dashboardData }) => ({
            competences: dashboardData?.competences,
        }),
        isFixed: true,
    },
    {
        id: "thematic-areas",
        component: ThematicAreasCard,
        getProps: ({ dashboardData }) => ({
            thematicAreas: dashboardData?.thematic_areas,
        }),
        isFixed: true,
    },
    {
        id: "historical",
        component: HistoricalDataCard,
        getProps: ({ simulations }) => ({ simulations }),
    },
    {
        id: "recommendations",
        component: RecommendationsCard,
        getProps: ({
            dashboardData,
            canEditRecommendations,
            onSaveRecommendations,
        }) => ({
            recommendations: dashboardData?.recommendations,
            isEditable: canEditRecommendations,
            onSave: onSaveRecommendations,
        }),
    },
];
